module.exports = __webpack_public_path__ + "static/media/INZ1017.19eaf228.pdf";